<template>
    <div id="frame-practicien">
        <h1>Gestion tiers payant</h1>
        <div id="container-gestionTierPayant">
            <div class="general-sous-menu">
                <h3>Tiers payant par défaut</h3>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Tiers payant AMO</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Tiers payant Comp./Mut</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Avec DRE</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Pour les invalidités</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h3>Gestion TP ASCS par défaut</h3>
                <div class="general-group">
                    <input type="radio" name="GTP_ACS_par_defaut" />
                    <label>En gestion AMC avec Contrat</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="GTP_ACS_par_defaut" />
                    <label>En TP Coordonné AMO (TOPM)</label>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    @import 'parametre.css';
</style>
<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Gestion Tiers Payant'
            }
        },

        computed: {

        },

        methods: {

        },

        props:[]
        ,
        mounted() {
            //console.log(this.remplacerEspaceParTrait(this.removeAccents("Gestion Tiers Payant")))
            console.log("ParametreGestion Tiers Pyant mounted");
        }
        ,
        created() {
            console.log("ParametreGestion Tiers Payant created");
        }

    });
</script>